import { RouterModule } from '@angular/router';
import { Component } from '@angular/core';
import { ToolbarComponent } from './shared/components/ui/toolbar/toolbar.component';

export interface MenuItem {
  label: string;
  icon: string;
}
@Component({
  selector: 'app-root',
  imports: [RouterModule, ToolbarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
